import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../Address.messages';

type ValidationMessageType = 'invalid' | 'required';

const getMessageKey = (type: ValidationMessageType): string =>
  ({
    invalid: 'invalidValidationError',
    required: 'requiredValidationError',
  }[type]);

const ValidationMessage: FC<{
  fieldNameKey: string;
  type: ValidationMessageType;
}> = ({ fieldNameKey, type }) => (
  <FormattedMessage
    {...messages[getMessageKey(type)]}
    values={{ field: <FormattedMessage {...messages[fieldNameKey]} /> }}
  />
);

export default ValidationMessage;
